import { makeSx } from '../../../theme/_utils'
import { defaultPalette } from '../../../theme/idsTheme'

export default makeSx({
    comparisonTable: {
        overflow: 'hidden',
        border: `0.5px solid ${defaultPalette.lightGrey.mediumDark}`,
        borderRadius: '0.75rem',
    },
})
